export default __webpack_public_path__ + "static/media/x_wdt_c_1.76059738.mp3";